const actions = {
  SET_STATE: "settings/SET_STATE",
  CHANGE_SETTING: "settings/CHANGE_SETTING",
  GET_SETTINGS: "settings/GET_SETTINGS",
  SET_USER_BUDGET_COLUMNS: "settings/SET_USER_BUDGET_COLUMNS",
  SET_USER_TABLE_COLUMNS: "settings/SET_USER_TABLE_COLUMNS",
  SET_USER_TABLE_COLUMNS_REQ: "settings/SET_USER_TABLE_COLUMNS_REQ",
  SET_WISHLIST: "settings/SET_WISHLIST",
  SET_WISHLIST_REQ: "settings/SET_WISHLIST_REQ",
};

export default actions;